import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { 
  AppBar, 
  Toolbar, 
  IconButton, 
  Button,
  Box,
  useMediaQuery,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemText
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import LogoutIcon from '@mui/icons-material/Logout'
import api from '../../utils/api'

const Header = () => {
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleLogout = async () => {
    // Call backend logout to clear httpOnly cookies
    console.log('Logout clicked')
    try {
      await api.post('/auth/logout')
      console.log('✅ Logout successful - cookies cleared')
    } catch (error) {
      console.error('❌ Logout error:', error)
    } finally {
      // Clear all auth data from localStorage
      localStorage.removeItem('authToken')
      localStorage.removeItem('username')
      localStorage.removeItem('mail')
      navigate('/login')
    }
  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  return (
    <AppBar 
      position="static" 
      elevation={0}
      sx={{ 
        backgroundColor: 'white',
        borderBottom: '1px solid #e0e0e0'
      }}
    >
      <Toolbar className="container mx-auto px-4">
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          {isMobile && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, color: '#004681' }}
            >
              <MenuIcon />
            </IconButton>
          )}
          
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={() => navigate('/')}
          >
            <Box
              component="img"
              src="/images/broadridge-logo.png"
              alt="Broadridge Financial Solutions"
              sx={{ 
                height: 40,
                mr: 2
              }}
            />
            <Box
              sx={{
                borderLeft: '1px solid #acacac',
                pl: 2,
                color: '#2f2f2f',
                fontSize: { xs: '14px', sm: '18px' },
                fontWeight: 500
              }}
            >
              Certificate Management
            </Box>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
            sx={{
              textTransform: 'none',
              borderRadius: '6px',
              px: 3,
              '&:hover': {
                backgroundColor: 'primary.main',
                color: 'white'
              }
            }}
          >
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Header
